import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';

import { SharedLanguageService } from '@language';
import { MHLocation } from '../../entities/mh-location.entity';
import { AbstractGeoService } from '../abstract/geo.abstract.service';
import { ShGoogleMapsService } from './google-maps.service';

@Injectable({ providedIn: 'root' })
export class ShGeoService extends AbstractGeoService {
    constructor(
        protected translateService: SharedLanguageService,
        private readonly googleMapsService: ShGoogleMapsService
    ) {
        super();
    }

    public getClientZoomLevel(): Observable<number> {
        return this.googleMapsService.getClientZoomLevel();
    }

    public getClientLocation(): Observable<google.maps.LatLngLiteral | null> {
        return this.googleMapsService.getClientLocation();
    }

    public loadApi(): Observable<boolean> {
        return this.googleMapsService.publicLoadApi();
    }

    public translate(token: string, params?: object | undefined): string {
        return this.translateService.instant(token, params);
    }

    public searchByAddress(formattedAddress: string): Observable<MHLocation | null> {
        if (!formattedAddress || formattedAddress === '') {
            return of(null);
        }

        return this.googleMapsService.searchByAddress(formattedAddress);
    }

    public searchByGeoLocation(geoLocation: string): Observable<MHLocation | null> {
        if (!geoLocation || geoLocation === '') {
            return of(null);
        }

        return this.googleMapsService.searchByGeoLocation(geoLocation);
    }
}
